// SERVICE_ALIASES
export const SPONSOR_LICENCE_SERVICE = "sponsor_licence";
export const CANDIDATE_ASSESSMENT_SERVICE = "candidate_assessment";
export const SKILLED_WORKER_SERVICE = "skilled_worker";
export const SKILLED_WORKER_INSIDE_SERVICE = "sw_inside";
export const COS_SKILLED_WORKER_SERVICE = "cos_sw";
export const COS_SKILLED_WORKER_INSIDE_SERVICE = "cos_sw_inside";
export const DEPENDANT_INSIDE_SERVICE = "dependant_inside";
export const ELIGIBILITY_CHECK_SERVICE = "eligibility_check";

export type TYPE_SERVICE = {
  [key: string]: any;
};

export const SERVICE_ALIASES = {
  [SKILLED_WORKER_SERVICE]: SKILLED_WORKER_SERVICE,
  [SPONSOR_LICENCE_SERVICE]: SPONSOR_LICENCE_SERVICE,
  [CANDIDATE_ASSESSMENT_SERVICE]: CANDIDATE_ASSESSMENT_SERVICE,
  [COS_SKILLED_WORKER_SERVICE]: COS_SKILLED_WORKER_SERVICE,
  [COS_SKILLED_WORKER_INSIDE_SERVICE]: COS_SKILLED_WORKER_INSIDE_SERVICE,
  [SKILLED_WORKER_INSIDE_SERVICE]: SKILLED_WORKER_INSIDE_SERVICE,
  [DEPENDANT_INSIDE_SERVICE]: DEPENDANT_INSIDE_SERVICE,
};

export const START_SERVICE_EVENT = "start";

export const NO_STATUS_SERVICE_STATUS = "no_status";
export const IN_PROGRESS_SERVICE_STATUS = "in_progress";
export const REPORT_GENERATION_SERVICE_STATUS = "report_generation";
export const REPORT_GENERATED_SERVICE_STATUS = "report_generated";
export const REPORT_CORRECTION_SERVICE_STATUS = "report_correction";
export const COMPLETE_SERVICE_STATUS = "complete";

export const EC_COMPLETED_STATUSES = [
  REPORT_GENERATED_SERVICE_STATUS,
  COMPLETE_SERVICE_STATUS,
  REPORT_CORRECTION_SERVICE_STATUS,
];

export const APPROVED_SERVICE_STATUS = "approved";
export const REJECTED_SERVICE_STATUS = "rejected";
export const TO_REVIEW_SERVICE_STATUS = "to_review";

export const SERVICE_STATUS = {
  [NO_STATUS_SERVICE_STATUS]: NO_STATUS_SERVICE_STATUS,
  [IN_PROGRESS_SERVICE_STATUS]: IN_PROGRESS_SERVICE_STATUS,
  [REPORT_GENERATION_SERVICE_STATUS]: REPORT_GENERATION_SERVICE_STATUS,
  [REPORT_GENERATED_SERVICE_STATUS]: REPORT_GENERATED_SERVICE_STATUS,
  [REPORT_CORRECTION_SERVICE_STATUS]: REPORT_CORRECTION_SERVICE_STATUS,
  [COMPLETE_SERVICE_STATUS]: COMPLETE_SERVICE_STATUS,
};

export const SPONSOR_LICENCE_SERVICE_TYPE = "Sponsor Licence";
export const CANDIDATE_ASSESSMENT_SERVICE_TYPE = "Candidate Assessment";
export const SKILLED_WORKER_SERVICE_TYPE = "Skilled Worker";
export const SKILLED_WORKER_INSIDE_SERVICE_TYPE = "Skilled Worker Inside";
export const SKILLED_WORKER_COS_SERVICE_TYPE = "Skilled Worker CoS";
export const SKILLED_WORKER_COS_INSIDE_SERVICE_TYPE = "Skilled Worker CoS Inside";
export const DEPENDANT_INSIDE_SERVICE_TYPE = "Dependant Inside";
export const ELIGIBILITY_CHECK_SERVICE_TYPE = "Eligibility Check";

export const SERVICE_TYPE = {
  [SKILLED_WORKER_SERVICE]: SKILLED_WORKER_SERVICE_TYPE,
  [SKILLED_WORKER_INSIDE_SERVICE_TYPE]: SKILLED_WORKER_INSIDE_SERVICE_TYPE,
  [SPONSOR_LICENCE_SERVICE]: SPONSOR_LICENCE_SERVICE_TYPE,
  [CANDIDATE_ASSESSMENT_SERVICE]: CANDIDATE_ASSESSMENT_SERVICE_TYPE,
  [COS_SKILLED_WORKER_SERVICE]: SKILLED_WORKER_COS_SERVICE_TYPE,
  [COS_SKILLED_WORKER_INSIDE_SERVICE]: SKILLED_WORKER_COS_INSIDE_SERVICE_TYPE,
};

export const SW_SERVICES_TYPES = [
  SKILLED_WORKER_SERVICE_TYPE,
  SKILLED_WORKER_INSIDE_SERVICE_TYPE,
  SKILLED_WORKER_COS_SERVICE_TYPE,
  SKILLED_WORKER_COS_INSIDE_SERVICE_TYPE,
];

export const DATA_SUBMISSION_SERVICE_STEP = "Data submission";
export const COMPLETED_SERVICE_STEP = "Completed";
export const REPORT_GENERATION_SERVICE_STEP = "Report generation";

export const PERSONAL_DETAILS_SERVICE_TAB = "personal_details";
export const CANDIDATE_DETAILS_SERVICE_TAB = "candidate_details";
export const COMPANY_DETAILS_SERVICE_TAB = "company_details";
export const EMPLOYMENT_SERVICE_TAB = "employment";
export const REPORT_TAB_SERVICE_TYPE = "report";

// ONLINE APPLICATION
export const IN_PROGRESS_OA_STATUS = "in_progress";
export const READY_TO_SUBMIT_OA_STATUS = "ready_to_submit";
export const ON_REVIEW_OA_STATUS = "on_review";
export const APPROVED_BY_EXPERT_OA_STATUS = "approved_by_expert";
export const APPROVED_BY_HO_OA_STATUS = "approved_by_ho";
export const REJECTED_BY_HO_OA_STATUS = "rejected_by_ho";

export const OA_STATUS = {
  [IN_PROGRESS_OA_STATUS]: IN_PROGRESS_OA_STATUS,
  [READY_TO_SUBMIT_OA_STATUS]: READY_TO_SUBMIT_OA_STATUS,
  [ON_REVIEW_OA_STATUS]: ON_REVIEW_OA_STATUS,
  [APPROVED_BY_EXPERT_OA_STATUS]: APPROVED_BY_EXPERT_OA_STATUS,
  [APPROVED_BY_HO_OA_STATUS]: APPROVED_BY_HO_OA_STATUS,
  [REJECTED_BY_HO_OA_STATUS]: REJECTED_BY_HO_OA_STATUS,
};

// CASES TEMPLATE
export const WITHDRAW_APPROVAL_LABEL = "Withdraw approval";
export const WITHDRAW_REJECTION_LABEL = "Withdraw rejection";
export const APPROVED_BY_HO_LABEL = "Approved by HO";
export const REJECTED_BY_HO_LABEL = "Rejected by HO";

// FINAL DECISION
export const APPROVED_FINAL_DECISION = "Approved";
export const REJECTED_FINAL_DECISION = "Rejected";

// SERVICE_ALIASES STEP NAME
export const CASE_CREATION_SERVICE_STEP = "Case creation";
export const DATA_AND_DOCUMENT_SUBMISSION_SERVICE_STEP = "Data & Document submission";
export const DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP = "Data & Documents submission";
export const EXPERT_REVIEW_SUBMISSION_SERVICE_STEP = "Expert review";
export const ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP = "Additional info for expert";
export const PAYMENT_SERVICE_STEP = "Payment";
export const APPLICATION_SUBMISSION_SERVICE_STEP = "Application submission";
export const VISA_DECISION_SERVICE_STEP = "Visa decision";
export const COS_CREATION_SERVICE_STEP = "CoS creation";
export const ID_CHECKS_SERVICE_STEP = "ID check";
export const FINAL_EXPERT_REVIEW_SERVICE_STEP = "Final expert review";
export const ADDITIONAL_DATA_AND_DOCUMENTS_SERVICE_STEP = "Additional data & documents";

export const SERVICE_STEP_NAMES = {
  [CASE_CREATION_SERVICE_STEP]: CASE_CREATION_SERVICE_STEP,
  [DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP]: DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP,
  [EXPERT_REVIEW_SUBMISSION_SERVICE_STEP]: FINAL_EXPERT_REVIEW_SERVICE_STEP,
  [ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP]: ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP,
  [PAYMENT_SERVICE_STEP]: PAYMENT_SERVICE_STEP,
  [APPLICATION_SUBMISSION_SERVICE_STEP]: APPLICATION_SUBMISSION_SERVICE_STEP,
  [VISA_DECISION_SERVICE_STEP]: VISA_DECISION_SERVICE_STEP,
  [COS_CREATION_SERVICE_STEP]: COS_CREATION_SERVICE_STEP,
  [ID_CHECKS_SERVICE_STEP]: ID_CHECKS_SERVICE_STEP,
  [FINAL_EXPERT_REVIEW_SERVICE_STEP]: FINAL_EXPERT_REVIEW_SERVICE_STEP,
  [ADDITIONAL_DATA_AND_DOCUMENTS_SERVICE_STEP]: ADDITIONAL_DATA_AND_DOCUMENTS_SERVICE_STEP,
};

export const SERVICE_STEPS = {
  case_creation: CASE_CREATION_SERVICE_STEP,
  data_and_documents_submission: DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP,
  expert_review: EXPERT_REVIEW_SUBMISSION_SERVICE_STEP,
  additional_info_for_expert: ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP,
  payment: PAYMENT_SERVICE_STEP,
  application: APPLICATION_SUBMISSION_SERVICE_STEP,
  visa_decision: VISA_DECISION_SERVICE_STEP,
  cos_creation: COS_CREATION_SERVICE_STEP,
  id_checks: ID_CHECKS_SERVICE_STEP,
  final_expert_review: FINAL_EXPERT_REVIEW_SERVICE_STEP,
  additional_data_and_documents: ADDITIONAL_DATA_AND_DOCUMENTS_SERVICE_STEP,
};

// SERVICE_ALIASES STEP ALIAS
export const DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP_ALIAS = "sw_step_data_submission";
export const COS_DATA_SUBMISSION_SERVICE_STEP_ALIAS = "cos_sw_inside_step_data_submission";
export const EXPERT_REVIEW_SUBMISSION_SERVICE_STEP_ALIAS = "sw_step_expert_review";
export const ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP_ALIAS = "sw_step_info";
export const PAYMENT_SERVICE_STEP_ALIAS = "sw_step_payment";
export const APPLICATION_SUBMISSION_SERVICE_STEP_ALIAS = "sw_step_application_submission";
export const VISA_DECISION_SERVICE_STEP_ALIAS = "sw_step_visa_decision";
export const COS_CREATION_SERVICE_STEP_ALIAS = "sw_step_cos_creation";
export const ID_CHECKS_SERVICE_STEP_ALIAS = "cos_sw_inside_step_id_check";
export const FINAL_EXPERT_REVIEW_SERVICE_STEP_ALIAS = "cos_sw_inside_step_final_expert_review";
export const ADDITIONAL_DATA_AND_DOCUMENTS_SERVICE_STEP_ALIAS =
  "cos_sw_inside_step_additional_data_and_docs";

export const SERVICE_STEP_ALIASES = {
  [DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP_ALIAS]: DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP_ALIAS,
  [COS_DATA_SUBMISSION_SERVICE_STEP_ALIAS]: COS_DATA_SUBMISSION_SERVICE_STEP_ALIAS,
  [EXPERT_REVIEW_SUBMISSION_SERVICE_STEP_ALIAS]: EXPERT_REVIEW_SUBMISSION_SERVICE_STEP_ALIAS,
  [ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP_ALIAS]: ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP_ALIAS,
  [PAYMENT_SERVICE_STEP_ALIAS]: PAYMENT_SERVICE_STEP_ALIAS,
  [APPLICATION_SUBMISSION_SERVICE_STEP_ALIAS]: APPLICATION_SUBMISSION_SERVICE_STEP_ALIAS,
  [VISA_DECISION_SERVICE_STEP_ALIAS]: VISA_DECISION_SERVICE_STEP_ALIAS,
  [COS_CREATION_SERVICE_STEP_ALIAS]: COS_CREATION_SERVICE_STEP_ALIAS,
  [ID_CHECKS_SERVICE_STEP_ALIAS]: ID_CHECKS_SERVICE_STEP_ALIAS,
  [FINAL_EXPERT_REVIEW_SERVICE_STEP_ALIAS]: FINAL_EXPERT_REVIEW_SERVICE_STEP_ALIAS,
  [ADDITIONAL_DATA_AND_DOCUMENTS_SERVICE_STEP_ALIAS]: ADDITIONAL_DATA_AND_DOCUMENTS_SERVICE_STEP_ALIAS,
};

export const SKILLED_WORKER_SERVICE_ID = 1;
export const COS_PLUS_SKILLED_WORKER_SERVICE_ID = 33;
export const COS_PLUS_SKILLED_WORKER_INSIDE_SERVICE_ID = 35;
export const SPONSOR_LICENCE_SERVICE_ID = 9;
export const CANDIDATE_ASSESSMENT_SERVICE_ID = 10;
export const SKILLED_WORKER_INSIDE_SERVICE_ID = 2512;

// Tabs
export const COS_TAB_NAME = "cos";
export const FINAL_APPLICATION_TAB_NAME = "final_application";

export const TAB_NAMES = {
  [COS_TAB_NAME]: COS_TAB_NAME,
  [FINAL_APPLICATION_TAB_NAME]: FINAL_APPLICATION_TAB_NAME,
};

// Cos
export const COS_CATEGORIES = [
  "Skilled Worker (Switching immigration category - ISC liable)",
  "Skilled Worker (Extensions - ISC exempt)",
  "Skilled Worker (Extensions - ISC liable)",
  "Skilled Worker (Changes of Employment - ISC exempt)",
  "Skilled Worker (Changes of Employment - ISC liable)",
  "Skilled Worker (graduate in Tier 4/Student Route switching to Skilled Worker)",
  "Skilled Worker (Switching immigration category - ISC exempt)",
];

// Candidates
export const STEPS_FOR_EDITING = [
  DATA_AND_DOCUMENT_SUBMISSION_SERVICE_STEP,
  DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP,
  DATA_SUBMISSION_SERVICE_STEP,
  // REPORT_GENERATION_SERVICE_STEP,
];

// Service update
export const TASKS_TO_TRIGGER_SERVICE_UPDATE = [
  "Submit your case for expert review",
  "Add Candidate(s) you want to sponsor",
];
export const STEPS_TO_TRIGGER_SERVICE_UPDATE = ["Identified Candidate"];

export const CASE_TEMPLATE_CASE_TYPE = {
  SL: "Sponsor Licence",
  EC: "Candidate Assessment",
  SW_OUTSIDE: "Skilled Worker",
  SW_INSIDE: "Skilled Worker Inside",
  SW_COS_OUTSIDE: "Skilled Worker CoS",
  SW_COS_INSIDE: "Skilled Worker CoS Inside",
  DEPENDANT_INSIDE: "Dependant Inside",
};
